"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const productSubtypes_1 = require("../../../utils/productSubtypes");
const product_1 = require("../../../sharedTypings/product");
const __1 = require("../..");
const { AMOUNT, DETAILS, SUBTYPE, } = product_1.ProductField;
const { THC_MG } = product_1.ProductDetailsField;
const { BEVERAGE, CARTRIDGE, CBD, EDIBLE, EXTRACT, FLOWER, MERCH, MISC, NON_INV, PILL, PLANT, PREROLL, TINCTURE, TOPICAL, } = product_1.ProductType;
const { NULL, NUMBER, OBJECT, STRING, } = __1.JSONSchemaType;
const beverageRequirements = {
    if: {
        properties: { type: { "const": BEVERAGE } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.beverageSubtypes, null],
            },
        },
        required: [DETAILS],
    }
};
const cartridgeRequirements = {
    if: {
        properties: { type: { "const": CARTRIDGE } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.cartridgeSubtypes, null],
            },
        },
        required: [
            AMOUNT,
            product_1.ProductField.UOM,
        ],
    }
};
const cbdRequirements = {
    if: {
        properties: { type: { "const": CBD } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.cbdSubtypes, null],
            },
        },
    }
};
const edibleRequirements = {
    if: {
        properties: { type: { "const": EDIBLE } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.edibleSubtypes, null],
            },
            details: {
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            }
        },
        required: [DETAILS]
    }
};
const extractRequirements = {
    if: {
        properties: { type: { "const": EXTRACT } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.extractSubtypes, null],
            },
        },
        required: [
            AMOUNT,
            product_1.ProductField.UOM,
        ]
    }
};
const CA_FLOWER_SUBTYPES = productSubtypes_1.flowerSubtypes.filter(f => ['KIEF', 'PRE-GROUND', 'PRE-PACK', 'PRE-PACK SMALLS'].includes(f));
const flowerRequirements = {
    if: {
        properties: { type: { "const": FLOWER } }
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: CA_FLOWER_SUBTYPES,
            }
        },
        required: [
            AMOUNT,
            product_1.ProductField.UOM,
            SUBTYPE,
        ]
    }
};
const merchRequirements = {
    if: {
        properties: { type: { "const": MERCH } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.merchSubtypes, null],
            },
        }
    }
};
const miscRequirements = {
    if: {
        properties: { type: { "const": MISC } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.miscSubtypes, null],
            },
        },
        required: [DETAILS],
    }
};
const nonInvRequirements = {
    if: {
        properties: { type: { "const": NON_INV } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.nonInvSubtypes, null],
            },
        }
    }
};
const pillRequirements = {
    if: {
        properties: { type: { "const": PILL } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.pillSubtypes, null],
            },
        },
        required: [DETAILS]
    },
};
const plantRequirements = {
    if: {
        properties: { type: { "const": PLANT } },
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.plantSubtypes,
            }
        },
        required: [SUBTYPE]
    },
};
const prerollRequirements = {
    if: {
        properties: { type: { "const": PREROLL } }
    },
    then: {
        if: {
            properties: { subtype: { "const": "INFUSED" } }
        },
        then: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.prerollSubtypes,
            },
            properties: {
                details: {
                    type: OBJECT,
                    properties: {
                        [THC_MG]: {
                            minimum: 0,
                            type: NUMBER,
                        },
                    },
                    required: [THC_MG]
                },
            },
            required: [
                AMOUNT,
                DETAILS,
                product_1.ProductField.UOM,
                SUBTYPE,
            ]
        },
        else: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.prerollSubtypes,
            },
            required: [
                AMOUNT,
                product_1.ProductField.UOM,
                SUBTYPE,
            ]
        },
    },
};
const tinctureRequirements = {
    if: {
        properties: { type: { "const": TINCTURE } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.tinctureSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
        },
        required: [DETAILS]
    }
};
const topicalRequirements = {
    if: {
        properties: { type: { "const": TOPICAL } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.topicalSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
        },
        required: [DETAILS]
    }
};
const requirements = {
    allOf: [
        beverageRequirements,
        cartridgeRequirements,
        cbdRequirements,
        edibleRequirements,
        extractRequirements,
        flowerRequirements,
        merchRequirements,
        miscRequirements,
        nonInvRequirements,
        pillRequirements,
        plantRequirements,
        prerollRequirements,
        tinctureRequirements,
        topicalRequirements
    ]
};
exports.default = requirements;
//# sourceMappingURL=data:application/json;base64,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